import {faRunning} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import React, {useEffect, useState} from 'react';
import Activity from "../Activity/Activity";

const Activities = (props) => {
    const {timeHandler} = props;

    const [activities, setActivities] = useState([]);

    useEffect(() => {

        fetch("activities.json")
            .then(res => res.json())
            .then(data => setActivities(data));
    }, []);

    return (
        <div className="col-span-3 my-20">
            <h1 className="text-4xl font-medium text-lime-500">
                <FontAwesomeIcon className="mr-3" icon={faRunning}></FontAwesomeIcon>
                Activity Plus
            </h1>
            <h3 className="mt-6 text-2xl font-medium">Select today's study plan</h3>
            <div className="mt-2 grid grid-cols-1 md:grid-cols-3 gap-2">
                {
                    activities.map((activity) => <Activity key={activity.id} activity={activity} timeHandler={timeHandler}></Activity>)
                }
            </div>
        </div>
    );
};

export default Activities;